export enum TextPosition {
    Automatic = "Automatic",
    Centre = "Centre",
    Above = "Above",
    Below = "Below",
    Left = "Left",
    Right = "Right"
}